/* unplugin-vue-components disabled */import script from "./Screen.vue?vue&type=script&setup=true&lang=ts"
export * from "./Screen.vue?vue&type=script&setup=true&lang=ts"

import "./Screen.vue?vue&type=style&index=0&id=1315ccfa&lang=less"

const __exports__ = script;

export default __exports__